// extracted by mini-css-extract-plugin
export default {"cardHover":"offersHotspot_cardHover__Exrja","HoverText":"offersHotspot_HoverText__1Is+b","buttonHoverEffect":"offersHotspot_buttonHoverEffect__cbhci"};